import React from 'react';

import { Box, Typography } from '@mui/material';

import Stats from './Stats';
import { useIntelState } from '../../context/IntelState';

const Resources: React.FC = () => {
  const { intelState } = useIntelState();
  console.log(intelState);
  return (
    <Box>
      <Typography variant='h4' component='div'>
        Resources
      </Typography>
      {intelState?.ownData && (
        <Box>
          <Typography variant='body1' component='div' sx={{ my: 1 }}>
            Our KD - {intelState.ownData.kingdomName}
            {', '}
            {intelState.ownData.location}
          </Typography>
          <Stats rows={intelState.ownData.provinces} />
        </Box>
      )}
      {intelState?.enemyData && (
        <Box>
          <Typography variant='body1' component='div' sx={{ my: 1 }}>
            Enemy KD - {intelState.enemyData.kingdomName}
            {', '}
            {intelState.enemyData.location}
          </Typography>
          <Stats rows={intelState.enemyData.provinces} />
        </Box>
      )}
    </Box>
  );
};

export default Resources;
